export default "__VITE_ASSET__BWmuKVRL__"